import { ApplicationConfig, ErrorHandler, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { getCustomPaginatorIntl } from './shared/utils/custom-paginator-intl';

import { MAT_TABS_CONFIG } from '@angular/material/tabs';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { loaderInterceptor } from './core/interceptors/loader.interceptor';
import { GlobalErrorHandlerService } from './core/services/global-error-handler.service';
import { authConfig } from './core/auth/auth.config';
import { AbstractSecurityStorage, DefaultLocalStorageService, provideAuth } from 'angular-auth-oidc-client';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideHttpClient(
      withInterceptors([
        authInterceptor,
        loaderInterceptor
      ]),
      withInterceptorsFromDi(),
    ),
    { provide: ErrorHandler, useClass: GlobalErrorHandlerService },
    provideRouter(routes, withComponentInputBinding()),
    provideAnimationsAsync(),
    {
      provide: MatPaginatorIntl,
      useValue: getCustomPaginatorIntl(),
    },
    { provide: MAT_TABS_CONFIG, useValue: { animationDuration: '0ms' } },
    provideAuth(authConfig),
    {
      provide: AbstractSecurityStorage,
      useClass: DefaultLocalStorageService,
    }
  ],
};
